import { deprecated } from 'typesafe-actions'
import { Result, IAppError, Descriptive } from '../../interfaces/base'
import {
  ProjectsSearchResult,
  ProjectsFilter,
} from '../../interfaces/services/projects'

import { Project, UnsavedProjectType } from '../../interfaces/entities/project'
import { IStringAnyMap } from '../../types/map'
import { PageSize } from '../../interfaces/components/table'
import { Ordering } from '../../interfaces/pages/projects'

const { createAction } = deprecated

export const filterUpdated = createAction(
  'projects/FILTER_UPDATED',
  (resolve) => {
    return (payload: ProjectsFilter) => resolve(payload)
  },
)

export const getProjects = createAction('projects/GET_PROJECTS', (resolve) => {
  return (filter: ProjectsFilter | null) => resolve(filter)
})

export const getProjectsCompleted = createAction(
  'projects/GET_PROJECTS_COMPLETED',
  (resolve) => {
    return (result: Result<ProjectsSearchResult, IAppError>) => resolve(result)
  },
)

export const saveProject = createAction('projects/SAVE_PROJECT', (resolve) => {
  return (project: Project | UnsavedProjectType) => resolve(project)
})

export const saveProjectCompleted = createAction(
  'projects/SAVE_PROJECT_COMPLETED',
  (resolve) => {
    return (
      result: Result<{ project: Project; created: boolean }, IAppError>,
    ) => resolve(result)
  },
)

export const doProjectAction = createAction(
  'projects/DO_PROJECT_ACTION',
  (resolve) => {
    return (action: Descriptive, project: Project, options?: IStringAnyMap) =>
      resolve({ action, project, options })
  },
)

export const doProjectActionComplete = createAction(
  'projects/DO_PROJECT_ACTION_COMPLETE',
  (resolve) => {
    return (response: Result<Project, IAppError>) => resolve(response)
  },
)

export const onCurrentPageChange = createAction(
  'projects/PAGE_CHANGED',
  (resolve) => {
    return (payload: number) => resolve(payload)
  },
)

export const onPageSizeChange = createAction(
  'projects/PAGE_SIZE_CHANGED',
  (resolve) => {
    return (payload: PageSize) => resolve(payload)
  },
)

export const onSortingChange = createAction(
  'projects/SORTING_CHANGED',
  (resolve) => {
    return (payload: Ordering) => resolve(payload)
  },
)
